import { Box, Typography, CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { MemberApi } from "../api/MemberApi";
import TanitaMC780Report from "./TanitaMC780Report";
import TanitaMC980Report from "./TanitaMC980Report";
import { mutedTextSx, loadingSpinnerSx } from "../styles/cyberTheme";

export default function TanitaSection({
    memberID = 0,
    year = "",
    autoLoad = true,
    initialData = null,
    theme,
}) {
    const [loading, setLoading] = useState(false);
    const [tanitaData, setTanitaData] = useState(initialData);
    const isCyber = theme === "cyberTheme";
    const currentMemberID = memberID;

    useEffect(() => {
        if (!autoLoad) return;
        setLoading(true);
        loadLastHealthData();
    }, [currentMemberID, year, autoLoad]);

    const loadLastHealthData = async () => {
        try {
            const result = await MemberApi.lastMemberHealthData(
                currentMemberID,
                year ? String(year) : ""
            );
            setTanitaData(result);
        } catch (error) {
            setTanitaData(null);
        } finally {
            setLoading(false);
        }
    };

    const statusTypographySx = isCyber
        ? { ...mutedTextSx, my: 4, textAlign: "center" }
        : { my: 4 };

    let content;

    if (loading) {
        content = isCyber ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
                <CircularProgress sx={loadingSpinnerSx} />
            </Box>
        ) : (
            <Typography variant="h4">載入中 ...</Typography>
        );
    } else if (tanitaData === null) {
        content = (
            <Typography variant="h5" sx={statusTypographySx}>
                未有相關紀錄，請前往測量站，進行健康評估。
            </Typography>
        );
    } else {
        const healthData = tanitaData.health_data;

        if (healthData.model == "MC-780") {
            content = (
                <Box sx={isCyber ? { "& .MuiTypography-h5": { fontSize: "1rem" } } : undefined}>
                    <TanitaMC780Report healthData={healthData} />
                </Box>
            );
        } else if (healthData.model == "MC-980") {
            content = (
                <Box sx={isCyber ? { "& .MuiTypography-h5": { fontSize: "1rem" } } : undefined}>
                    <TanitaMC980Report healthData={healthData} />
                </Box>
            );
        } else {
            content = (
                <Typography variant="h5" sx={statusTypographySx}>
                    無法顯示該型號的報告
                </Typography>
            );
        }
    }

    if (isCyber) {
        return <Box sx={{ color: "#E0D0FF" }}>{content}</Box>;
    }

    return content;
}
